{
  "id": "christmas",
  "name": "Christmas",
  "description": "A festive theme based on a coolors palette",
  "colors": {
    "light": {
      "primary": "#004733",
      "secondary": "#568d66",
      "positive": "#2b6a4d",
      "negative": "#cb0b0a",
      "warning": "#F2C037",
      "important": "#8e0413",
      "light": "#f3f4f6",
      "dark": "#004733",
      "surface": "#ffffff",
      "darksurface": "#dcdfe5",
      "white": "#ffffff"
    },
    "dark": {
      "primary": "#a5c1ae",
      "secondary": "#568d66",
      "positive": "#568d66",
      "negative": "#df8080",
      "warning": "#F2C037",
      "important": "#df8080",
      "light": "#dcdfe5",
      "dark": "#0f1e18",
      "surface": "#004733",
      "darksurface": "#003829",
      "white": "#f3f4f6"
    }
  }
}
